import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState } from '@mews-commander/types';
import { Stack, StackItem } from '@optimus-web/core';
import { getCountrySubdivisionName } from '@mews-commander/legacy-entities/src/ducks/countrySubdivisions';
import { getCountryName } from '@mews-commander/legacy-entities/src/ducks/countries';
import { AddressSource } from '../types';

interface Props {
    countryName: string;
    countrySubdivisionName: string | undefined;
}

type OwnProps = Pick<AddressSource, 'countryCode' | 'countrySubdivisionCode'>;

const AddressCountry: React.FC<Props> = ({ countryName, countrySubdivisionName }) => (
    <Stack vertical>
        <StackItem>{countryName}</StackItem>
        <StackItem>{countrySubdivisionName}</StackItem>
    </Stack>
);

export default connect<Props, {}, OwnProps, ApplicationState>(
    createStructuredSelector({
        countryName: getCountryName,
        // @ts-expect-error
        countrySubdivisionName: getCountrySubdivisionName,
    })
)(AddressCountry);
